import * as React from "react"
import { getRoleLabel } from "shared/helpers/getLabel"
import { Avatar } from "ui/components"
import { SocketStatusEnum } from "shared/stores/useSocketStore"
import { RelativeElement } from "ui/components/RelativeElement"

type Props = {
    avatarUrl: string,
    firstname: string,
    lastname: string,
    roles: string[]
    socketStatus?: SocketStatusEnum
}

export const UserProfil = ({
    avatarUrl,
    firstname,
    lastname,
    roles,
    socketStatus
}: Props) => {

    const label = roles.map(getRoleLabel).join(', ').replace(/\,$/g, '')

    return (
        <div className="text-sm user-profil">
            <RelativeElement>
                <Avatar
                    src={avatarUrl}
                    name={`${firstname ?? ''} ${lastname ?? ''}`}
                    className="w-9 h-9 rounded-full ring-2 ring-white dark:ring-color8 shadow-soft"
                />
                <div className="absolute -bottom-0.5 -right-0.5" title={socketStatus === SocketStatusEnum.Disconnected ? 'Hors ligne' : 'En ligne'}>
                    <span className="relative flex h-3 w-3">
                        {
                            socketStatus === SocketStatusEnum.Disconnected ? (
                                <>
                                    <span className="inline-flex rounded-full h-3 w-3 bg-rose-500 border-2 border-white dark:border-color8"></span>
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                                </>
                            )
                            :
                                (<span className="inline-flex rounded-full h-3 w-3 bg-emerald-400 border-2 border-white dark:border-color8"></span>)
                        }
                    </span>
                </div>
            </RelativeElement>
            <div className="min-w-0 leading-tight max-w-[11rem]">
                <div className="truncate font-semibold text-[13px] text-ink dark:text-white">{firstname} {lastname}</div>
                <div className="truncate text-[11.5px] text-slate-400 mt-0.5">{label}</div>
            </div>
        </div>
    )
}